import { useEffect, useState, useContext } from 'react'
import { GlobalContext } from '../../GlobalContext'
import Paginate from '../../ui-elements/Paginate'
import ChecklistReminderAlert from './ChecklistReminderAlert'

type Props = {
    remindersToDisplay: Array<ObjectStringKeyAnyValue> | null
    setRemindersToDisplay: React.Dispatch<React.SetStateAction<any>>
    isExpanded: boolean
}


function ChecklistReminders({
    remindersToDisplay,
    setRemindersToDisplay,
    isExpanded
}: Props) {

    const {
        tableData
    } = useContext(GlobalContext)



    const [displayItems, setDisplayItems] = useState<ObjectStringKeyAnyValue>({})
    const arrayStartIndex = displayItems.indexOfFirstItem || 0
    const arrayEndIndex = displayItems.indexOfLastItem || 5
    const arrayToDisplay: any[] = remindersToDisplay ? remindersToDisplay.slice(arrayStartIndex, arrayEndIndex) : []





    if (!remindersToDisplay || remindersToDisplay.length === 0) {
        // return <p className={`${isExpanded ? '' : 'hidden'} pt-2`}>No checklist reminders</p>
        return null
    }

    return <div className={`${isExpanded ? '' : 'hidden'} pt-1 w-full flex flex-col items-start justify-between gap-2`}>
        <Paginate
            setDisplayItems={setDisplayItems}
            itemsPerPage={6}
            maxPageNumbersToDisplay={5}
            arrayToPageThrough={remindersToDisplay || []}
        >
            {arrayToDisplay && arrayToDisplay.map((thisReminder, index) => {
                return <ChecklistReminderAlert key={index} thisReminder={thisReminder} />
            })}
        </Paginate>
    </div>
}
export default ChecklistReminders